import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'
import ExternalLink from '@/components/view/utils/link/ExternalLink'
import InternalLink from '@/components/view/utils/link/InternalLink'

interface Props extends ChildProps {
  link?: string
  newTab?: boolean
  critical?: boolean
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  onMouseDown?: MouseEventHandler<HTMLButtonElement>
}

const DisclosureRow = ({
  children,
  link,
  newTab = false,
  critical = false,
  onClick,
  onMouseDown,
  disabled = false
}: Props) => {
  const Tag = newTab ? ExternalLink : InternalLink
  const className =
    'bg-fill-primary rounded-lg p-2 block w-full text-left outline-default min-w-[192px]'
  const hoverActiveClass = disabled
    ? 'pointer-events-none'
    : critical
    ? 'text-critical hover:bg-surface-critical-hover active:bg-surface-critical-active'
    : 'text-primary hover:bg-surface-hover active:bg-surface-active'

  return (
    <>
      {link ? (
        <Tag className={clsx(className, hoverActiveClass)} link={link}>
          {children}
          {newTab && (
            <Icon
              color={
                critical ? IconColor.CRITICAL : disabled ? IconColor.DISABLED : IconColor.PRIMARY
              }
              type={IconType.NEW_TAB}
            />
          )}
        </Tag>
      ) : (
        <button
          type='button'
          className={clsx(className, hoverActiveClass)}
          onClick={onClick}
          onMouseDown={onMouseDown}
          disabled={disabled}
        >
          {children}
        </button>
      )}
    </>
  )
}

export default DisclosureRow
